import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Helpers from '@Apis/helpers';
import H3Text from '@Uilib/h3Text';
import {
  CaretRightOutlined,
} from '@ant-design/icons';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import PropTypes from 'prop-types';
import './style.scss';
/**
 *
 */
class ListPurchaseRequests extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   */
  componentDidMount() {
    const { getPurchaseRequests, selectedMO, user } = this.props;
    getPurchaseRequests(selectedMO?.tenant_id, '', '', '', '', '', '', 1, 30, '', '', '', selectedMO?.mo_id);
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      user, purchaseRequests, getPurchaseRequestsLoading, history,
    } = this.props;
    // const { } = this.state;

    return (
      <Fragment>
        {getPurchaseRequestsLoading ? (
          <div className="list-pr__wrapper-loading">
            <div className="loadingBlock list-pr__wrapper-item " />
            <div className="loadingBlock list-pr__wrapper-item " />
          </div>
        ) : Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ, user) && purchaseRequests?.purchase_requisition?.length > 0 && (
          <div className="list-pr__wrapper">
            <H3Text text="MATERIAL REQUESTS" className="list-pr__title" />
            {purchaseRequests?.purchase_requisition.map((item) => (
              <Link to={`/purchase/purchase-request/view/${item?.purchase_requisition_id}`} target="_blank">
                <div key={item?.pr_number} className="list-pr__item-header">
                  <CaretRightOutlined />
                  <div>
                    <H3Text text={`MR# ${item?.pr_number}`} className="list-pr__item-header-id" />
                    <div
                      className="list-pr__item-header-status"
                      style={{ backgroundColor: Helpers.getStatusColor(item?.status)?.color }}
                    >
                      {Helpers.getStatusColor(item?.status)?.text}
                    </div>
                  </div>
                  <H3Text text={`${item?.lines_count} Item(s)`} className="list-pr__item-header-total" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserReducers, PurchaseRequestReducers, MOReducers }) => ({
  user: UserReducers.user,
  purchaseRequests: PurchaseRequestReducers.purchaseRequests,
  selectedMO: MOReducers.selectedMO,
  getPurchaseRequestsLoading: PurchaseRequestReducers.getPurchaseRequestsLoading,

});

const mapDispatchToProps = (dispatch) => ({
  getPurchaseRequests: (tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, callback, searchKeyword, tenantDepartmentId, moId) => dispatch(
    PurchaseRequestActions.getPurchaseRequests(tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, callback, searchKeyword, tenantDepartmentId, moId),
  ),

});

ListPurchaseRequests.propTypes = {
  user: PropTypes.any,
  purchaseRequests: PropTypes.any,
  selectedMO: PropTypes.any,
  getPurchaseRequests: PropTypes.func,
  history: PropTypes.func,
  getPurchaseRequestsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ListPurchaseRequests));
